module.exports = __webpack_public_path__ + "img/IMG_9928_FoamcoreMatted.4c4eee1a.jpg";